export default __webpack_public_path__ + "static/media/aergo.4f66bddb.webp";